<template>
  <header class="portal-header">
    <b-row align-v="center" align-h="center" class="hide-sm">
      <b-col sm="12" xl="8">
        <b-row align-v="center">
          <div id="logo-sistema"></div>
          <b-col
            ><div class="portal-title">
              PAGAMENTOS DE TRIBUTOS DO PARANÁ</div></b-col
          >
          <b-col md="2" lg="1"></b-col>
        </b-row>
      </b-col>
    </b-row>
<!-- <b-row>
   <b-col sm="12" xl="8">
    <div class="region region-header">
       <section id="block-celeparheader" class="block block-celepar-blocks-custom-header block-celepar-header clearfix">
          <b-row class="celeparheader">
            <b-col sm="12" md="5" xl="7">
              <a href="#" id="btn-mobile-menu">
                <i class="fas fa-bars" aria-hidden="true"></i>
              </a>
              <h1 class="logo">
                <span class="logo-image">
                  <span class="sr-only">SECRETARIA DA FAZENDA</span>
                </span>
                <span class="nome-instituicao">
                  Secretaria da Fazenda do Estado do Paraná
                </span>
              </h1>
            </b-col>
          </b-row>
       </section>
    </div>
   </b-col>
</b-row> -->
    <b-row align-h="center" class="menu-bg">
      <PortalMenu></PortalMenu>
    </b-row>
  </header>
</template>

<script>
import { application } from '@/application.js'
import PortalMenu from './components/PortalMenu.vue'
export default {
  components: {
    PortalMenu
  },
  data () {
    return {
      AppInfo: application,
      contracted: false
    }
  },

  methods: {
    toggleSidebar () {
      let sidebar =
        this.$store.getters.getSidebar === 'sidebar-expanded'
          ? 'sidebar-contracted'
          : 'sidebar-expanded'
      this.contracted = sidebar === 'sidebar-contracted'
      this.$store.commit('setSidebar', sidebar)
    },
    toggleSidebarSm () {}
  }
}
</script>

<style lang="scss">

</style>
